// source: pbtypes/vehicle/skills/actions/toggle_photo_interval_mode/toggle_photo_interval_mode.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_skills_mission_camera_settings_pb = require('../../../../../pbtypes/vehicle/skills/mission_camera_settings_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_mission_camera_settings_pb);
var pbtypes_gen_user_camera_exposure_mode_pb = require('../../../../../pbtypes/gen/user_camera/exposure_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_user_camera_exposure_mode_pb);
goog.exportSymbol('proto.skills.TogglePhotoIntervalModeActionArgs', null, global);
goog.exportSymbol('proto.skills.TogglePhotoIntervalModeActionStateData', null, global);
goog.exportSymbol('proto.skills.TogglePhotoIntervalModeResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TogglePhotoIntervalModeActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TogglePhotoIntervalModeActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TogglePhotoIntervalModeActionArgs.displayName = 'proto.skills.TogglePhotoIntervalModeActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TogglePhotoIntervalModeResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TogglePhotoIntervalModeResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TogglePhotoIntervalModeResultData.displayName = 'proto.skills.TogglePhotoIntervalModeResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TogglePhotoIntervalModeActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TogglePhotoIntervalModeActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TogglePhotoIntervalModeActionStateData.displayName = 'proto.skills.TogglePhotoIntervalModeActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TogglePhotoIntervalModeActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TogglePhotoIntervalModeActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
enable: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
useRangeInterval: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
rangeInterval: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
useTimeInterval: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
timeInterval: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
cameraSettings: (f = msg.getCameraSettings()) && pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.toObject(includeInstance, f),
photoSettings: (f = msg.getPhotoSettings()) && pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.toObject(includeInstance, f),
photoType: (f = msg.getPhotoType()) && pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoType.toObject(includeInstance, f),
photoFormat: (f = msg.getPhotoFormat()) && pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoFormat.toObject(includeInstance, f),
photoQuality: jspb.Message.getFieldWithDefault(msg, 8, 0),
exposureMode: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TogglePhotoIntervalModeActionArgs;
  return proto.skills.TogglePhotoIntervalModeActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TogglePhotoIntervalModeActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseRangeInterval(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRangeInterval(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUseTimeInterval(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTimeInterval(value);
      break;
    case 10:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.deserializeBinaryFromReader);
      msg.setCameraSettings(value);
      break;
    case 11:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.deserializeBinaryFromReader);
      msg.setPhotoSettings(value);
      break;
    case 6:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoType;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoType.deserializeBinaryFromReader);
      msg.setPhotoType(value);
      break;
    case 7:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoFormat;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoFormat.deserializeBinaryFromReader);
      msg.setPhotoFormat(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPhotoQuality(value);
      break;
    case 9:
      var value = /** @type {!proto.user_camera.ExposureMode.Enum} */ (reader.readEnum());
      msg.setExposureMode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TogglePhotoIntervalModeActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TogglePhotoIntervalModeActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnable();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getUseRangeInterval();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getRangeInterval();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getUseTimeInterval();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getTimeInterval();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getCameraSettings();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.serializeBinaryToWriter
    );
  }
  f = message.getPhotoSettings();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.serializeBinaryToWriter
    );
  }
  f = message.getPhotoType();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoType.serializeBinaryToWriter
    );
  }
  f = message.getPhotoFormat();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoFormat.serializeBinaryToWriter
    );
  }
  f = message.getPhotoQuality();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getExposureMode();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional bool enable = 1;
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getEnable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setEnable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool use_range_interval = 2;
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getUseRangeInterval = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setUseRangeInterval = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional float range_interval = 3;
 * @return {number}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getRangeInterval = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setRangeInterval = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional bool use_time_interval = 4;
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getUseTimeInterval = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setUseTimeInterval = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional float time_interval = 5;
 * @return {number}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getTimeInterval = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setTimeInterval = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional CameraSettings camera_settings = 10;
 * @return {?proto.skills.CameraSettings}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getCameraSettings = function() {
  return /** @type{?proto.skills.CameraSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings, 10));
};


/**
 * @param {?proto.skills.CameraSettings|undefined} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
*/
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setCameraSettings = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.clearCameraSettings = function() {
  return this.setCameraSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.hasCameraSettings = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PhotoSettings photo_settings = 11;
 * @return {?proto.skills.PhotoSettings}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getPhotoSettings = function() {
  return /** @type{?proto.skills.PhotoSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings, 11));
};


/**
 * @param {?proto.skills.PhotoSettings|undefined} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
*/
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setPhotoSettings = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.clearPhotoSettings = function() {
  return this.setPhotoSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.hasPhotoSettings = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional PhotoType photo_type = 6;
 * @return {?proto.skills.PhotoType}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getPhotoType = function() {
  return /** @type{?proto.skills.PhotoType} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoType, 6));
};


/**
 * @param {?proto.skills.PhotoType|undefined} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
*/
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setPhotoType = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.clearPhotoType = function() {
  return this.setPhotoType(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.hasPhotoType = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PhotoFormat photo_format = 7;
 * @return {?proto.skills.PhotoFormat}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getPhotoFormat = function() {
  return /** @type{?proto.skills.PhotoFormat} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoFormat, 7));
};


/**
 * @param {?proto.skills.PhotoFormat|undefined} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
*/
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setPhotoFormat = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.clearPhotoFormat = function() {
  return this.setPhotoFormat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.hasPhotoFormat = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 photo_quality = 8;
 * @return {number}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getPhotoQuality = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setPhotoQuality = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional user_camera.ExposureMode.Enum exposure_mode = 9;
 * @return {!proto.user_camera.ExposureMode.Enum}
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.getExposureMode = function() {
  return /** @type {!proto.user_camera.ExposureMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.user_camera.ExposureMode.Enum} value
 * @return {!proto.skills.TogglePhotoIntervalModeActionArgs} returns this
 */
proto.skills.TogglePhotoIntervalModeActionArgs.prototype.setExposureMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TogglePhotoIntervalModeResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TogglePhotoIntervalModeResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TogglePhotoIntervalModeResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TogglePhotoIntervalModeResultData}
 */
proto.skills.TogglePhotoIntervalModeResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TogglePhotoIntervalModeResultData;
  return proto.skills.TogglePhotoIntervalModeResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TogglePhotoIntervalModeResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TogglePhotoIntervalModeResultData}
 */
proto.skills.TogglePhotoIntervalModeResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TogglePhotoIntervalModeResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TogglePhotoIntervalModeResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TogglePhotoIntervalModeResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TogglePhotoIntervalModeActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TogglePhotoIntervalModeActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TogglePhotoIntervalModeActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TogglePhotoIntervalModeActionStateData}
 */
proto.skills.TogglePhotoIntervalModeActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TogglePhotoIntervalModeActionStateData;
  return proto.skills.TogglePhotoIntervalModeActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TogglePhotoIntervalModeActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TogglePhotoIntervalModeActionStateData}
 */
proto.skills.TogglePhotoIntervalModeActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TogglePhotoIntervalModeActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TogglePhotoIntervalModeActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TogglePhotoIntervalModeActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TogglePhotoIntervalModeActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
